import { jsx as e } from "react/jsx-runtime";
const i = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "12",
    height: "9",
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.8 5.90285L2.04853 3.15137C1.83137 2.93422 1.53137 2.7999 1.2 2.7999C0.537258 2.7999 0 3.33716 0 3.9999C0 4.33127 0.134315 4.63127 0.351472 4.84843L3.95147 8.44843C4.16863 8.66559 4.46863 8.7999 4.8 8.7999C5.13137 8.7999 5.43137 8.66559 5.64853 8.44843L11.6485 2.44843C11.8657 2.23127 12 1.93127 12 1.5999C12 0.937161 11.4627 0.399902 10.8 0.399902C10.4686 0.399902 10.1686 0.534217 9.95147 0.751374L4.8 5.90285Z",
        fill: "white"
      }
    )
  }
);
export {
  i as CheckedMarkIcon
};
//# sourceMappingURL=CheckedMarkIcon.js.map
